"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRegisteredFunction = void 0;
const common_1 = require("@finley-technologies/common");
const arrayformula_1 = require("./standard/array/arrayformula");
const date_1 = require("./standard/date/date");
const day_1 = require("./standard/date/day");
const days_1 = require("./standard/date/days");
const eomonth_1 = require("./standard/date/eomonth");
const month_1 = require("./standard/date/month");
const networkdays_1 = require("./standard/date/networkdays");
const today_1 = require("./standard/date/today");
const year_1 = require("./standard/date/year");
const pmt_1 = require("./standard/financial/pmt");
const and_1 = require("./standard/logical/and");
const if_1 = require("./standard/logical/if");
const iferror_1 = require("./standard/logical/iferror");
const isblank_1 = require("./standard/logical/isblank");
const not_1 = require("./standard/logical/not");
const or_1 = require("./standard/logical/or");
const abs_1 = require("./standard/math/abs");
const floor_1 = require("./standard/math/floor");
const max_1 = require("./standard/math/max");
const min_1 = require("./standard/math/min");
const round_1 = require("./standard/math/round");
const rounddown_1 = require("./standard/math/rounddown");
const roundup_1 = require("./standard/math/roundup");
const sum_1 = require("./standard/math/sum");
const sumproduct_1 = require("./standard/math/sumproduct");
const lower_1 = require("./standard/text/lower");
const search_1 = require("./standard/text/search");
const text_1 = require("./standard/text/text");
const upper_1 = require("./standard/text/upper");
const functionRegistry = {
    ABS: abs_1.ABS,
    AND: and_1.AND,
    ARRAYFORMULA: arrayformula_1.ARRAYFORMULA,
    DATE: date_1.DATE,
    DAY: day_1.DAY,
    DAYS: days_1.DAYS,
    EOMONTH: eomonth_1.EOMONTH,
    FLOOR: floor_1.FLOOR,
    IF: if_1.IF,
    IFERROR: iferror_1.IFERROR,
    ISBLANK: isblank_1.ISBLANK,
    LOWER: lower_1.LOWER,
    MAX: max_1.MAX,
    MIN: min_1.MIN,
    MONTH: month_1.MONTH,
    NETWORKDAYS: networkdays_1.NETWORKDAYS,
    NOT: not_1.NOT,
    OR: or_1.OR,
    PMT: pmt_1.PMT,
    ROUND: round_1.ROUND,
    ROUNDDOWN: rounddown_1.ROUNDDOWN,
    ROUNDUP: roundup_1.ROUNDUP,
    SEARCH: search_1.SEARCH,
    SUM: sum_1.SUM,
    SUMPRODUCT: sumproduct_1.SUMPRODUCT,
    TEXT: text_1.TEXT,
    TODAY: today_1.TODAY,
    UPPER: upper_1.UPPER,
    YEAR: year_1.YEAR,
};
const getRegisteredFunction = (functionName) => {
    const registeredFunction = functionRegistry[functionName];
    (0, common_1.finleyAssert)(registeredFunction, `${functionName} not implemented`);
    return registeredFunction;
};
exports.getRegisteredFunction = getRegisteredFunction;
//# sourceMappingURL=index.js.map